import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CreateProfessionalDevelopmentRecordCommand, SimpleSelectOptionDto } from 'src/shared/services/api.service';

@Component({
  selector: 'cert-pd-award-form',
  standalone: false,
  templateUrl: './pd-award-form.component.html',
})
export class ProfessionalDevelopmentAwardFormComponent implements OnInit {
  @Input() disabled = false;
  @Input() disabledTooltip = '';
  @Input() personIds: number[] = [];
  @Input() professionalDevelopmentTypeOptions: SimpleSelectOptionDto[] = [];
  @Output() create = new EventEmitter<CreateProfessionalDevelopmentRecordCommand>();

  command!: CreateProfessionalDevelopmentRecordCommand;

  ngOnInit() {
    this.command = {
      personIds: this.personIds,
      description: undefined,
      hours: undefined,
      completionDate: undefined,
      professionalDevelopmentTypeCodeId:
        this.professionalDevelopmentTypeOptions.length === 1
          ? this.professionalDevelopmentTypeOptions[0].id
          : undefined,
      leaCodeId: 0,
    };
  }

  onSubmit() {
    this.create.emit(this.command);
  }

  resetForm() {
    this.command = {
      personIds: this.personIds,
      description: undefined,
      hours: undefined,
      completionDate: undefined,
      professionalDevelopmentTypeCodeId:
        this.professionalDevelopmentTypeOptions.length === 1
          ? this.professionalDevelopmentTypeOptions[0].id
          : undefined,
      leaCodeId: 0,
    };
  }
}
